import React, { useState } from 'react'
import moment from 'moment'

const withState = WrappedComponent => {
  return props => {
    const { date } = props
    const [selectedDate, selectDate] = useState(date || moment())

    return (
      <WrappedComponent
        selectDate={selectDate}
        selectedDate={selectedDate}
        {...props}
      />
    )
  }
}

export default withState
